import React, { Suspense, lazy } from "react";
import Navbar from '../Header/Navbar'
import Banner from '../Carousel/Banner'
import NavbarSecond from '../Header/NavbarSecond'
import Footer from '../Footer/Footer'
import MobileNavbar from '../Header/MobileNavbar'
import { Helmet } from "react-helmet";

const WhyEapro = lazy(() => import("../HomePageComponent/WhyEapro/WhyEapro"));
const OurSpecialization = lazy(() => import("../HomePageComponent/OurSpecialization/OurSpecialization"));
const OurProductSection = lazy(() => import("../HomePageComponent/OurProductSection/OurProductSection"));
const PillarsOfEAPRO = lazy(() => import("../HomePageComponent/PillarsOfEAPRO/PillarsOfEAPRO"));
const KnowledgeCentreSlider = lazy(() => import("../HomePageComponent/KnowledgeCentreSlider/KnowledgeCentreSlider"));
const DesignSolarPowerLoadCal = lazy(() => import("../HomePageComponent/DesignSolarPowerLoadCal/DesignSolarPowerLoadCal"));
const KnowMoreAboutPower = lazy(() => import("../HomePageComponent/KnowMoreAboutPower/KnowMoreAboutPower"));
const HelpAndSupport = lazy(() => import("../HomePageComponent/HelpAndSupport/HelpAndSupport"));

const Home = () => {
  return (
    <>
      <Helmet>
        {/* Page Title and Meta tags */}
        <title>EAPRO : Top Solar Inverter, Battery and Panel Company In India</title>
        <meta name="description" content="EAPRO, India's leading provider of high-quality solar inverters, batteries, and panels. Power your home or business with reliable, sustainable energy solutions from a trusted brand." />
        <meta name="keywords" content="Solar Inverter, Solar Battery, Solar Panel, Solar Panel Company India, EAPRO Solar Panel, EAPRO Solar Battery, EAPRO Solar Inverter, Eapro Global Ltd" />
        <meta name="robots" content="INDEX,FOLLOW" />
        <link rel="canonical" href="https://www.eapro.in/" />



        <meta property="og:type" content="website" />
        <meta property="og:title" content=">EAPRO : Top Solar Inverter, Battery and Panel Company In India" />
        <meta property="og:description" content="EAPRO, India's leading provider of high-quality solar inverters, batteries, and panels. Power your home or business with reliable, sustainable energy solutions from a trusted brand." />
        <meta property="og:url" content="https://www.eapro.in/" />
        <meta property="og:image" content="https://www.eapro.in/images/specialization2.png" />

        
  <meta name="twitter:card" content="https://www.eapro.in/images/specialization2.png" />
  <meta name="twitter:title" content=">EAPRO : Top Solar Inverter, Battery and Panel Company In India" />
  <meta name="twitter:description" content="EAPRO, India's leading provider of high-quality solar inverters, batteries, and panels. Power your home or business with reliable, sustainable energy solutions from a trusted brand." />
  <meta name="twitter:image" content="https://www.eapro.in/images/specialization2.png" />


      </Helmet>
      <Navbar />
      <NavbarSecond />
      <MobileNavbar />
      <Banner />
          <Suspense fallback={<div>Loading...</div>}>
      <WhyEapro />
      <OurSpecialization />
      <OurProductSection />
      <PillarsOfEAPRO />
      <KnowledgeCentreSlider />
      <DesignSolarPowerLoadCal />
      <KnowMoreAboutPower />
      <HelpAndSupport />
      </Suspense>
      <Footer />
    </>
  )
}

export default Home